import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { House, ReceiptText, Grid2x2, UserRound } from "lucide-react";
import "./BottomNav.css";
import LoginModal from "../LoginModal/LoginModal";
import useTranslate from "../../hooks/useTranslate";

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");
  const { t } = useTranslate();

  const [showModal, setShowModal] = useState(false);

  const navItems = [
    {
      id: "/home",
      label: t("home"),
      Icon: House,
    },
    {
      id: "/deposit",
      label: t("deposit"),
      Icon: ReceiptText,
    },
    {
      id: "/promotions",
      label: t("promotion"),
      Icon: Grid2x2,
    },
    {
      id: "/profile",
      label: t("myAccount"),
      Icon: UserRound,
    },
  ];

  return (
    <nav className="bottom-nav-b">
      {navItems.map((item) => {
        const isActive =
          location.pathname === item.id ||
          (item.id === "/profile" &&
            (location.pathname === "/profile" ||
              location.pathname === "/login"));

        return (
          <button
            key={item.id}
            type="button"
            className={`bottom-nav-b-item ${isActive ? "active" : ""}`}
            onClick={() => {
              if (item.id === "/profile" || item.id === "/deposit") {
                if (isLoggedIn) {
                  navigate(item.id);
                } else {
                  setShowModal(true);
                }
              } else {
                navigate(item.id);
              }
            }}
          >
            <item.Icon className="bottom-nav-b-icon" strokeWidth={2.1} />
            <span className="bottom-nav-b-label">{item.label}</span>
          </button>
        );
      })}

      <LoginModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onLogin={(data) => console.log("login data:", data)}
        onRegister={() => console.log("register")}
        onForgotPassword={() => console.log("forgot password")}
      />
    </nav>
  );
};

export default BottomNav;